import { render, staticRenderFns } from "./ProfilesTableUser.vue?vue&type=template&id=389ceb49&scoped=true"
import script from "./ProfilesTableUser.vue?vue&type=script&lang=js"
export * from "./ProfilesTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ceb49",
  null
  
)

export default component.exports